import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_BANNERS,
  GET_BANNER_DETAILS,
  CREATE_BANNER,
  UPDATE_BANNER,
  DELETE_BANNER,
} from "./actionTypes"
import {
  getBannersFail,
  getBannersSuccess,
  getBannerDetailsSuccess,
  getBannerDetailsFail,
  createBannerFail,
  createBannerSuccess,
  updateBannerSuccess,
  updateBannerFail,
  deleteBannerSuccess,
  deleteBannerFail,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

// Banner - This line cannot be edited or removed
function getBannersAPi({ page, sort, limit, searchText }) {
  return get(
    `/banner/admin/all/?page=${page ? page : 1}&sort=${sort || ""}&limit=${
      limit ? limit : 10
    }&search=${searchText}`
  )
}

const getBannerDetailsAPi = bannerId => {
  return get(`/banner/admin/${bannerId}`)
}

const createBannerApi = ({ banner,onCloseClick }) => {
  return post("/banner/admin/new", banner,onCloseClick)
}

const updateBannerApi = ({ banner, bannerId,onCloseClick }) => {
  return ApiPut(`/banner/admin/${bannerId}`, banner,onCloseClick)
}

const deleteBannerApi = ({ bannerId }) => {
  return del(`/banner/admin/${bannerId}`)
}

function* fetchBanners({ payload }) {

  try {
    const response = yield call(getBannersAPi, payload)
    yield put(getBannersSuccess(response))
  } catch (error) {
    yield put(getBannersFail(error))
  }
}

function* fetchBannerDetails({ payload: bannerId }) {
  try {
    const response = yield call(getBannerDetailsAPi, bannerId)
    yield put(getBannerDetailsSuccess(response))
  } catch (error) {
    yield put(getBannerDetailsFail(error))
  }
}

function* onCreateBanner({ payload }) {
  try {
    const response = yield call(createBannerApi, payload)

    yield put(createBannerSuccess(response))
    try {
      const response = yield call(getBannersAPi, payload)
      yield put(getBannersSuccess(response))
    } catch (error) {
      yield put(getBannersFail(error))
    }
    if (payload?.onCloseClick) {
      payload?.onCloseClick()
    }
    doneNotification("Banner Created Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createBannerFail(error))
  }
}

function* onUpdateBanner({ payload }) {
  try {
    const response = yield call(updateBannerApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Banner Updated Successfully!",
        title: "",
      })
      yield put(updateBannerSuccess(response))
      if (payload?.onCloseClick) {
        payload?.onCloseClick()
      }
      try {
        const response = yield call(getBannersAPi, payload)
        yield put(getBannersSuccess(response))
      } catch (error) {
        yield put(getBannersFail(error))
      }
      if (payload.history) {
        payload.history.push("/banners")
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateBannerFail(error.response.data))
  }
}

function* onDeleteBanner({ payload }) {
  try {
    const response = yield call(deleteBannerApi, payload)
    yield put(deleteBannerSuccess(response))

    try {
      const response = yield call(getBannersAPi, payload)
      yield put(getBannersSuccess(response))
    } catch (error) {
      yield put(getBannersFail(error))
    }
    doneNotification("Banner Deleted Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteBannerFail(error?.response?.data))
  }
}

function* bannerSaga() {
  yield takeEvery(GET_BANNERS, fetchBanners)
  yield takeEvery(GET_BANNER_DETAILS, fetchBannerDetails)
  yield takeEvery(CREATE_BANNER, onCreateBanner)
  yield takeEvery(UPDATE_BANNER, onUpdateBanner)
  yield takeEvery(DELETE_BANNER, onDeleteBanner)
}

export default bannerSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
